import { useMutation } from '@tanstack/react-query';
import { useTenantedClient } from '../stores/org';

export const useRetryStackframe = (runKey: string, onSuccess: () => void) => {
  const client = useTenantedClient();
  return useMutation({
    mutationFn: async () => {
      const res = await client.atc.retryRunKey({ runKey });
      return res;
    },
    onSuccess: () => {
      onSuccess();
    },
  });
};
